import React from 'react';
import { cn } from '../../utils/cn';

const Button = React.forwardRef(({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className, 
  ...props 
}, ref) => {
  const baseClasses = 'reddit-btn inline-flex items-center justify-center gap-2';
  
  const variants = {
    primary: 'reddit-btn-primary',
    secondary: 'reddit-btn-secondary',
    outline: 'reddit-btn-outline',
    ghost: 'hover:bg-reddit-100 dark:hover:bg-dark-border',
  };
  
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
  };
  
  return (
    <button
      ref={ref}
      className={cn(baseClasses, variants[variant], sizes[size], className)}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;